import React, { useMemo } from 'react'
import { ButtonBase, ButtonBaseProps, withLinkWrapper, TextProps } from '.'
import { theme } from 'theme'

interface ButtonTextProps extends ButtonBaseProps {
    activeFontWeight?: string
}

const ButtonText: React.FC<ButtonTextProps> = ({
    color = theme.colors.black,
    isActive = false,
    px = 3,
    fontWeight = 'normal',
    activeFontWeight = 'bold',
    fontSize = '1em',
    textProps,
    children,
    ...props
}) => {
    const mergedtextProps = useMemo(
        () =>
            ({
                color,
                fontSize,
                fontWeight: isActive ? activeFontWeight : fontWeight,
                ...textProps,
            }) as TextProps,
        [color, fontSize, fontWeight, activeFontWeight, isActive, textProps],
    )
    return (
        <ButtonBase bg="transparent" px={px} textProps={mergedtextProps} isActive={isActive} {...props}>
            {children}
        </ButtonBase>
    )
}

export default ButtonText
export const ButtonTextLink = withLinkWrapper(ButtonText)
